module.exports = __webpack_public_path__ + "6amhealth_logo_white.png";